import { render, staticRenderFns } from "./ProfileInterest.vue?vue&type=template&id=27adfe1c&scoped=true&"
import script from "./ProfileInterest.vue?vue&type=script&lang=js&"
export * from "./ProfileInterest.vue?vue&type=script&lang=js&"
import style0 from "./ProfileInterest.vue?vue&type=style&index=0&id=27adfe1c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27adfe1c",
  null
  
)

export default component.exports